import { defineComponent, inject, watch } from 'vue';
import useParentComponentEffect from '../../hooks/useParentComponentEffect';
import { callWhenDifferentValue, isString, bindEvents } from '../../utils';

var script = /*#__PURE__*/ defineComponent(Object.assign({
    name: 'BContextMenu',
    inheritAttrs: false
}, { __name: 'index', props: {
        width: { type: Number, required: false, default: 100 },
        visible: { type: Boolean, required: false, default: true },
        menuItems: { type: Array, required: false, default: () => [] },
        onOpen: { type: null, required: false },
        onClose: { type: null, required: false }
    }, emits: ['initd', 'unload', 'open', 'close'], setup(__props, { emit: vueEmits }) {
        const props = __props;
        const getParentInstance = inject('getOverlayInstance', () => null);
        let contextMenu;
        const { ready } = useParentComponentEffect((map) => {
            const target = getParentInstance() || map;
            const cal = () => {
                contextMenu && target.removeContextMenu(contextMenu);
            };
            const init = () => {
                const { width, menuItems, visible } = props;
                contextMenu = new BMapGL.ContextMenu();
                for (const item of menuItems) {
                    if (isString(item) && item === '-') {
                        contextMenu.addSeparator();
                        continue;
                    }
                    const menuItem = new BMapGL.MenuItem(item.text, function (point, pixel) {
                        item.callback.call(null, {
                            point,
                            pixel,
                            map,
                            BMapGL,
                            target: target
                        });
                    }, {
                        width,
                        id: String(Math.random())
                    });
                    item.disabled ? menuItem.disable() : menuItem.enable();
                    contextMenu.addItem(menuItem);
                }
                visible && target.addContextMenu(contextMenu);
                bindEvents(props, vueEmits, contextMenu);
            };
            watch(() => props.visible, (n) => {
                if (contextMenu) {
                    target[n ? 'addContextMenu' : 'removeContextMenu'](contextMenu);
                }
            });
            watch(() => {
                return props.menuItems;
            }, callWhenDifferentValue(() => {
                cal();
                init();
            }), {
                deep: true
            });
            init();
            ready(map, contextMenu);
            // 在地图上添加点标记
            return cal;
        });
        return (_ctx, _cache) => {
            return null;
        };
    } }));

script.__file = "packages/components/contextMenu/index.vue";

export { script as default };
